<template>
  <v-app-bar-nav-icon
    class="d-sm-none"
    @click.stop="controls.drawer = !controls.drawer"
  ></v-app-bar-nav-icon>
</template>

<script>
import ControlsMixin from '@/utils/mixins/Controls'
export default {
  mixins: [ControlsMixin]
}
</script>

<style></style>
